const Snippets = ({ size = 18 }) => {
  return (
    <svg width={size} height={size} fill={'grey'} viewBox="0 0 512 512">
      <path
        d="M970 4455v-485h970v320l-202 2-203 3 90 32c340 122 693 150 1040 83 527-102 995-416 1279-860 27-41 50-76 51-78 6-7 274 153 275 164 0 14-129 204-198 288-301 373-740 654-1207 772-497 126-1016 86-1480-115l-90-39-3 199-2 199H970v-485zM248 3507c-118-233-191-470-230-742-16-116-16-453 1-575 70-520 298-978 668-1344l107-106H400V420h970v960h-320l-2-212-3-212-65 58c-197 175-383 430-487 671-115 263-165 503-165 785 0 319 59 582 192 859 33 68 58 127 55 131s-51 34-107 66c-57 32-117 66-133 76l-31 17-56-112zM4092 2567l-342-342 115-115 115-115 135 135c74 74 135 131 135 127 0-29-26-168-47-252-84-338-243-628-481-876-187-195-347-313-577-424-243-117-549-195-770-195h-75V180l93 6c150 9 314 33 446 65 480 117 923 400 1237 789 250 308 435 734 484 1110 6 47 13 100 16 119l6 34 154-154 154-154 115 115 115 115-343 343-342 342-343-343z"
        transform="matrix(.1 0 0 -.1 0 512)"
      ></path>
    </svg>
  );
};

export default Snippets;
